module.exports = __webpack_public_path__ + "img/kommune-1160.d81af4a9.svg";